import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import GarageIcon from '../../../assets/Icons/GarageIcon'
import TextBox from '../../../common/TextBox'
import DropDownV3 from '../../../common/DropDownV3'
import { isCheckSeatFareLimit, navigation1, navigation3, useDebouncedHandler } from '../../../utils/helpers'
import { emptySeatObj, genderOptList, seatDefaultObj } from '../constant'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import { useDispatch } from 'react-redux'
import { showErrorAlert } from '../../../redux/Actions'
const PassengerSeat = (props) => {
    const { obj, index, filterOpt, selectedSeat = [], setSelectedSeat = () => { }, bkgDeatails } = props
    const dispatch = useDispatch()
    const genderProps = () => {
        return {
            name: "Gender",
            id: `gender-${index}`,
            label: "",
            isCompulsory: false,
            options: genderOptList || [],
            preSelectedValues: obj.gender || [],
            searchPlaceholder: "Search by Gender",
            disabled: false,
            isObject: true,
            primaryKey: 'id',
            labelKey: 'label',
            singleSelect: true,
            selectAllOption: false,
            defaultAllSelected: false,
            nextId: `psgName-${index}`,
            prevId: `SeatLabel-${index}`
        }
    }


    const handleGender = (val) => {
        let oldSeat = [...selectedSeat]
        oldSeat[index]['gender'] = val
        setSelectedSeat([...oldSeat])
    }

    const handleInputField = (event) => {
        if (index === 0 && event.target.name === 'name') {
            localStorage.setItem('BBTPsgName', event.target.value)
        }
        let oldSeat = [...selectedSeat]
        oldSeat[index][event.target.name] = event.target.value
        setSelectedSeat([...oldSeat])
    }
    const handleSeatLabel = (event) => {
        let value = event.target.value
        let chartData = filterOpt?.chartData || []
        let oldSeat = selectedSeat
        let filterSeat = chartData.filter((item) => item.SeatLabel?.toLowerCase() === value?.toLowerCase())
        if (filterSeat?.length > 0 && filterSeat?.[0]?.IsAvailable === 1) {
            let checkAlreadySeat = selectedSeat.filter((item) => item.SeatLabel?.toLowerCase() === value?.toLowerCase())
            if (checkAlreadySeat.length === 0) {
                oldSeat[index] = { ...oldSeat[index], ...filterSeat[0], baseFare: bkgDeatails?.seatFareIsDiscount ? filterSeat[0]?.disBaseFare : filterSeat[0]?.baseFare }
                setSelectedSeat([...oldSeat])
            } else {
                oldSeat[index] = { ...oldSeat[index], ...emptySeatObj }
                setSelectedSeat([...oldSeat])
            }
        } else {
            oldSeat[index] = { ...oldSeat[index], ...emptySeatObj }
            setSelectedSeat(JSON.parse(JSON.stringify([...oldSeat])))
        }
    }
    const handleAddSeat = () => {
        if (selectedSeat.length)
            setSelectedSeat((prev) => ([
                ...prev,
                seatDefaultObj,
            ]))

    }
    const handleRemoveSeat = () => {
        let newData = selectedSeat.filter((item, itemIndex) => itemIndex !== index)
        setSelectedSeat(newData)

    }
    const debouncedSeatLabel = useDebouncedHandler(handleSeatLabel, 500);
    const debouncedInputField = useDebouncedHandler(handleInputField, 500);
    const handleAllSeatPaxName = (event) => {
        let value = event.target.value
        let newData = selectedSeat.map((item, itemIndex) => ((itemIndex !== index && item.name?.toString()?.trim() === '') ? { ...item, name: value } : item))
        setSelectedSeat(newData)
    }
    let disableFare = !(bkgDeatails?.roleRight?.AllowFareChange2 === 1)

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            flexWrap={'wrap'}
            alignItems="stretch"
            sx={{ padding: '0px', paddingBottom: '12px' }}
            columnSpacing={{ xs: '8px' }}
            rowSpacing={{ xs: '12px' }}
        >
            <Grid item size={2} className='smallTextBox28'>
                <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '8px' }}>
                    <GarageIcon />
                    <TextBox placeholder='Seat No.' value={obj.SeatLabel}
                        id={`SeatLabel-${index}`} maxLength={3} type={'text'} onChange={debouncedSeatLabel}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' && event.target.value?.toString().trim() === '') {
                                dispatch(showErrorAlert('Enter Seat Number', `SeatLabel-${index}`))
                            } else {
                                navigation1(event, `gender-${index}`, index === 0 ? bkgDeatails?.roleRight?.AllowAutoCancelMinChange === 1 && bkgDeatails?.bkgType?.[0]?.id === "AP" ? 'autoCancelMins' : 'manualTicketNo' : `addRemove_seat_btn-${index - 1}`)
                            }
                        }}
                    />
                </Box>
            </Grid>
            <Grid item size={2} className='smallDropDownp28'>
                <DropDownV3
                    {...genderProps()}
                    onSelect={handleGender}
                />
            </Grid>
            <Grid item size={4} className='smallTextBox28'>
                <TextBox placeholder='Passenger Name' id={`psgName-${index}`} type={'text'} value={obj.name} name='name'
                    onChange={debouncedInputField}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && event.target.value?.toString().trim() === '') {
                            dispatch(showErrorAlert('Enter Passenger Name', `psgName-${index}`))
                        } else {
                            handleInputField(event)
                            navigation1(event, `psgAge-${index}`, `gender-${index}`)
                        }
                    }}
                    onBlur={(event) => {
                        if (index === 0) {
                            handleAllSeatPaxName(event)
                        }
                    }}
                />
            </Grid>
            <Grid item size={4} className='smallTextBox28 ageAndBtn_container'>
                <TextBox placeholder='Age' maxLength={3} type={'number'} value={obj.age} id={`psgAge-${index}`} name='age' onChange={debouncedInputField}
                    onKeyDown={(event) => {
                        handleInputField(event)
                        navigation1(event, `addRemove_seat_btn-${index}`, `psgName-${index}`)
                    }}

                />
                <Box className={`baseFare_seatInput ${Number(obj.orgBaseFare) - Number(obj.baseFare) > 0 ? 'discountSeat' : ''}`}>
                    <TextBox placeholder='Base Fare' maxLength={6} type={'number'} value={obj.baseFare} id={`baseFare-${index}`} name='baseFare' onChange={debouncedInputField}
                        disabled={disableFare}
                        onKeyDown={(event) => {
                            handleInputField(event)
                            navigation1(event, `addRemove_seat_btn-${index}`, `psgAge-${index}`)
                        }}
                        onBlur={(event) => {
                            const { value } = event.target;
                            let checkLimit = isCheckSeatFareLimit(bkgDeatails, obj.orgBaseFare, value)
                            if (checkLimit) {
                                let limitOnFareChange = bkgDeatails?.limitOnFareChange || 0
                                let limitOnFareChangePer = bkgDeatails?.limitOnFareChangePer || 0
                                dispatch(showErrorAlert(`Fare cannot be changed more than ${limitOnFareChangePer > 0 ? `${limitOnFareChangePer} %` : `${Number(limitOnFareChange || 0)} Rs`}`))
                                handleInputField({
                                    target: { name: 'baseFare', value: Number(obj.disBaseFare) }
                                })
                            }
                        }}
                    />
                </Box>
                <Box sx={{ display: 'flex', gap: '6px', height: '100%', minWidth: '80px' }}>
                    <>
                        {index === 0 ?
                            <Box className='addAndRemoveBtn' id={`addRemove_seat_btn-${index}`} tabIndex={0} onClick={handleAddSeat}
                                onKeyDown={(event) => {
                                    navigation3(event, ((selectedSeat?.length - 1) === index) ? 'PickUp' : `SeatLabel-${index + 1}`, `psgAge-${index}`, () => {
                                        handleAddSeat()
                                    })
                                }}
                            >
                                <AddCircleOutlineRoundedIcon />
                                <Typography>Add</Typography>
                            </Box>
                            :
                            <Box className='addAndRemoveBtn' id={`addRemove_seat_btn-${index}`} tabIndex={0} onClick={handleRemoveSeat}
                                onKeyDown={(event) => {
                                    navigation3(event, ((selectedSeat?.length - 1) === index) ? 'PickUp' : `SeatLabel-${index + 1}`, `psgAge-${index}`, () => {
                                        handleRemoveSeat()
                                    })
                                }}
                            >
                                <RemoveCircleOutlineRoundedIcon />
                                <Typography>Remove</Typography>
                            </Box>
                        }
                    </>
                </Box>
            </Grid>
        </Grid>
    )
}

export default PassengerSeat